function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilitary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m49.5 58.00293-40-.00586a1.00005 1.00005 0 0 1 -1-1v-55.99414a.99943.99943 0 0 1 1-1h34a1.001 1.001 0 0 1 .707.293l6 5.99414a.99928.99928 0 0 1 .293.707v50.00586a1.00026 1.00026 0 0 1 -1 1zm-39-2.00586 38 .00586v-48.5918l-5.41406-5.4082h-32.58594z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.50293 61-40-.00586a1.00005 1.00005 0 0 1 -1-1v-55.99414a.99943.99943 0 0 1 1-1h2.99707a1 1 0 0 1 0 2h-1.99707v53.99414l38 .00586v-2.00293a1 1 0 0 1 2 0v3.00293a1.00026 1.00026 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5 63.99707-40-.00586a1.00005 1.00005 0 0 1 -1-1v-55.99414a.99943.99943 0 0 1 1-1h2.99707a1 1 0 0 1 0 2h-1.99707v53.99414l38 .00586v-2.00293a1 1 0 0 1 2 0v3.00293a1.00026 1.00026 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.5 7.99707h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5 7.99707a.99943.99943 0 0 1 -1-1v-5.99414a1 1 0 1 1 2 0v5.99414a.99943.99943 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5 13.99121a.99942.99942 0 0 1 -1-1 1 1 0 1 0 -2 0 1 1 0 0 1 -2 0 3 3 0 1 1 6 0 .99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.5 47.99121a.99942.99942 0 0 1 -1-1v-34a1 1 0 1 1 2 0v34a.99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5 47.99121a.99942.99942 0 0 1 -1-1v-34a1 1 0 1 1 2 0v34a.99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.501 50.99121a.99845.99845 0 0 1 -.833-.44531l-2-3a1 1 0 1 1 1.664-1.10938l2 3a1 1 0 0 1 -.83105 1.55469z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.499 50.99121a1 1 0 0 1 -.83105-1.55469l2-3a1 1 0 0 1 1.66405 1.10938l-2 3a.99845.99845 0 0 1 -.833.44531z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.5 51.99121a.99942.99942 0 0 1 -1-1v-1a1 1 0 1 1 2 0v1a.99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5 45.99121h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5 16.99121a.99942.99942 0 0 1 -1-1 1.00067 1.00067 0 0 0 -1-1 1 1 0 0 1 0-2 3.00328 3.00328 0 0 1 3 3 .99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5 28.99121a.99942.99942 0 0 1 -1-1v-12a1 1 0 1 1 2 0v12a.99942.99942 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.5 14.99121h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5 23.99121h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 33.99707h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 30.99707h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 36.99707h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 39.99707h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5 42.99707h-13a1 1 0 0 1 0-2h13a1 1 0 1 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 50.99707h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5 52.99707a.99943.99943 0 0 1 -1-1v-4a1 1 0 0 1 2 0v4a.99943.99943 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.499 52.99707a1.00009 1.00009 0 0 1 -.79882-1.59961l3-4a.99961.99961 0 1 1 1.5996 1.19922l-3 4a.99553.99553 0 0 1 -.80078.40039z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.5 52.99707a.99943.99943 0 0 1 -1-1v-4a1 1 0 0 1 2 0v4a.99943.99943 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5 24.99121a9 9 0 1 1 9-9 9.00984 9.00984 0 0 1 -9 9zm0-16a7 7 0 1 0 7 7 7.0085 7.0085 0 0 0 -7-7z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.28125 21a.99266.99266 0 0 1 -.46484-.11523l-2.31641-1.21677-2.31641 1.2168a.99949.99949 0 0 1 -1.45019-1.05372l.44238-2.5791-1.874-1.82617a.99965.99965 0 0 1 .55469-1.70508l2.58886-.377 1.15821-2.3457a1.04012 1.04012 0 0 1 1.793 0l1.15821 2.3457 2.58886.377a.99965.99965 0 0 1 .55469 1.70508l-1.874 1.82617.44238 2.5791a1.00024 1.00024 0 0 1 -.98543 1.16892zm-2.78125-3.46191a.98967.98967 0 0 1 .46484.11523l.98829.51856-.18848-1.09961a.99977.99977 0 0 1 .28711-.88477l.7998-.7793-1.10449-.16113a.9982.9982 0 0 1 -.75293-.54687l-.49414-1-.49414 1a.9982.9982 0 0 1 -.75293.54687l-1.10449.16113.7998.7793a.99977.99977 0 0 1 .28711.88477l-.18847 1.09961.98828-.51856a.98967.98967 0 0 1 .46484-.11523z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilitary);
export default __webpack_public_path__ + "static/media/military.e18407e2ad64044e6b7194fa6319c741.svg";
export { ForwardRef as ReactComponent };